var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapricorn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Capricorn") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capricorn",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,2 C3.791,2 2,3.791 2,6 L4,6 C4,4.897 4.897,4 6,4 C7.103,4 8,4.897 8,6 L10,6 C10,3.791 8.209,2 6,2",
    id: "Head",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,2 C9.791,2 8,3.791 8,6 L8,13 L10,13 L10,6 C10,4.897 10.897,4 12,4 C13.103,4 14,4.897 14,6 L14,18 L16,18 L16,6 C16,3.791 14.209,2 12,2",
    id: "Top-Tail",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,22 L10,22 L10,20 L12,20 C13.103,20 14,19 14,18 L16,18 C16,20 14.209,22 12,22 Z",
    id: "Tail",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,14 C15.791,14 14,15.791 14,18 C14,20.209 15.791,22 18,22 C20.209,22 22,20.209 22,18 C22,15.791 20.209,14 18,14 M18,16 C19.103,16 20,16.897 20,18 C20,19.103 19.103,20 18,20 C16.897,20 16,19.103 16,18 C16,16.897 16.897,16 18,16",
    id: "Head",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapricorn);
export default __webpack_public_path__ + "static/media/capricorn.e8e60bb32558d5613be8f6e5dd3c81c4.svg";
export { ForwardRef as ReactComponent };